module.exports = __webpack_public_path__ + "static/media/pic1.bb7c2ac0.jpg";